module.exports = __webpack_public_path__ + "img/left-bracket.4520db8e.svg";